// extracted by mini-css-extract-plugin
export default {"DenseCell":"DenseCell_DenseCell__hXboW","NameColumn":"DenseCell_NameColumn__hTxh+","PrimaryCompany":"DenseCell_PrimaryCompany__PBZ-n","MultiRow":"DenseCell_MultiRow__edk1w"};